import { ClientUserSsoProviderType } from "../Types-DTOs/ClientUser";
import { atom } from "recoil";

export type RegisterState = {
  step: number;
  ssoProvider: ClientUserSsoProviderType | undefined;
  ssoToken: string | undefined;
  email: string | undefined;
  password: string | undefined;
  phone: string | undefined;
  name: string | undefined;
  businessName: string | undefined;
  gclid: string | undefined;
  referralCode: string | undefined;
};

export const registerState = atom<RegisterState>({
  key: "registerState",
  default: {
    step: 1,
    ssoProvider: undefined,
    ssoToken: undefined,
    email: undefined,
    password: undefined,
    phone: undefined,
    name: undefined,
    businessName: undefined,
    gclid: undefined,
    referralCode: undefined,
  } as RegisterState,
});
